import type { ReactNode } from 'react';
import { EM_DASH } from '../lib/formatters';

export interface Fact {
  label: string;
  /** Null / empty renders an em dash — never a made-up default. */
  value: ReactNode;
  mono?: boolean;
}

/** Label / value pairs that stay readable at 375px (labels wrap, values break). */
export function FactList({ facts, className }: { facts: Fact[]; className?: string }) {
  return (
    <dl className={`grid grid-cols-[minmax(0,7.5rem)_1fr] gap-x-3 gap-y-2 text-sm ${className ?? ''}`}>
      {facts.map((f) => {
        const empty = f.value === null || f.value === undefined || f.value === '';
        return (
          <div key={f.label} className="contents">
            <dt className="text-text-muted">{f.label}</dt>
            <dd className={`min-w-0 break-words text-text ${f.mono ? 'font-mono text-[13px]' : 'font-medium'}`}>
              {empty ? <span className="font-normal text-text-faint">{EM_DASH}</span> : f.value}
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
